import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=d3312ee8&scoped=true&"
import script from "./StarIcon.vue?vue&type=script&lang=ts&"
export * from "./StarIcon.vue?vue&type=script&lang=ts&"
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=d3312ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3312ee8",
  null
  
)

export default component.exports